export default __webpack_public_path__ + "media/titles/title_1_locale_de-01b785f3.png";